import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  Stack,
  Fade,
} from '@mui/material'
import localization from '../utils/localization'
import ServerUtils from '../utils/server'
import FormInput from '../components/FormInput'
import toast from 'react-hot-toast'
import ConstUtils from '../utils/const'

function ModalFeedback(props) {
  const [feedbackContent, setFeedbackContent] = useState('')
  const [feedbackContentErr, setFeedbackContentErr] = useState('')

  useEffect(() => {
    if (props.open) {
      setFeedbackContent('')
      setFeedbackContentErr('')
    }
  }, [props.open])

  function feedback() {
    if (feedbackContent === '') {
      setFeedbackContentErr(localization.strings.required)
      return
    }
    ServerUtils.feedback({
      app_id: ConstUtils.appID,
      type: 1,
      message: feedbackContent,
    }).then(async (resp) => {
      toast.success(localization.strings.thankFeedback)
      props.onClose()
    })
  }

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '28px',
          p: 1,
          overflow: 'visible',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 800,
          textAlign: 'center',
          pt: 4,
          pb: 1,
          color: '#1E293B',
        }}
      >
        {localization.strings.feedback}
      </DialogTitle>

      <DialogContent sx={{ px: 3, pb: 4 }}>
        <Fade in={props.open} timeout={500}>
          <Box sx={{ mt: 1 }}>
            <Typography variant="body2" sx={{ color: '#64748B', textAlign: 'center', mb: 4 }}>
              {localization.strings.thankFeedback}
            </Typography>

            <Stack spacing={3}>
              <FormInput
                label={localization.strings.feedbackContent}
                multiline={true}
                rows={4}
                value={feedbackContent}
                placeholder={localization.strings.inputFeedbackContentHint}
                error={feedbackContentErr}
                onChange={(event) => {
                  setFeedbackContent(event.target.value)
                  setFeedbackContentErr('')
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '16px',
                    backgroundColor: '#F8FAFC',
                  },
                }}
              />

              <Stack direction="row" spacing={2}>
                <Button
                  fullWidth
                  variant="text"
                  onClick={props.onClose}
                  sx={{
                    borderRadius: '14px',
                    py: 1.5,
                    fontWeight: 700,
                    color: '#64748B',
                    textTransform: 'none',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.03)' },
                  }}
                >
                  {localization.strings.cancel}
                </Button>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={feedback}
                  sx={{
                    borderRadius: '14px',
                    py: 1.5,
                    fontWeight: 700,
                    backgroundColor: '#1E88E5',
                    boxShadow: '0 8px 20px rgba(30, 136, 229, 0.2)',
                    textTransform: 'none',
                    '&:hover': { backgroundColor: '#1565C0' },
                  }}
                >
                  {localization.strings.confirm}
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Fade>
      </DialogContent>
    </Dialog>
  )
}

export default ModalFeedback
